import Notiflix from 'notiflix';

const Notifier = (function () {

    let notify = function(type, message, config, callback) {

        if (typeof callback === 'undefined') {
            callback = false;
        }

        if (typeof config === 'undefined') {
            config = false;
        }

        let defaultConfig = {
            timeout: 2000,
            showOnlyTheLastOne: true,
            clickToClose: true,
            plainText: false,
            cssAnimationStyle: 'from-right',
            messageMaxLength: 2000
        };

        let finalConfig = defaultConfig;

        if (config !== false) {
            finalConfig = $.extend(defaultConfig, config);
        }

        if (type === 'success') {
            finalConfig.success = {};
            finalConfig.success.background = '#419d55';
            Notiflix.Notify.success(message, callback, finalConfig);
        }
        if (type === 'error') {
            finalConfig.error = {};
            finalConfig.error.background = '#c44d58';
            finalConfig.timeout = 4000;
            Notiflix.Notify.failure(message, callback, finalConfig);
        }
        if (type === 'warning') {
            finalConfig.warning = {};
            finalConfig.warning.background = '#e5802c';
            Notiflix.Notify.warning(message, callback, finalConfig);
        }
        if (type === 'info') {
            finalConfig.info = {};
            finalConfig.info.background = '#2c93a3';
            Notiflix.Notify.info(message, callback, finalConfig);
        }
    };

    let success = function(message, config, callback) {
        notify('success', message, config, callback);
    }

    let error = function(message, config, callback) {
        notify('error', message, config, callback);
    }

    let warning = function(message, config, callback) {
        notify('warning', message, config, callback);
    }

    let info = function(message, config, callback) {
        notify('info', message, config, callback);
    }

    return {
      success: success,
      error: error,
      warning: warning,
      info: info,
    };
})();

window.Notifier = Notifier;
